import { useEffect, useCallback } from "react";

export function getDraftStorageKey(borrowerType, productId) {
  const type = String(borrowerType || "unknown").toLowerCase();
  const product = String(productId || "draft").trim();
  return `ds_borrower_form_draft_${type}_${product}`;
}

export function loadFormDraft(storageKey) {
  if (!storageKey || typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveFormDraft(storageKey, data) {
  if (!storageKey || typeof window === "undefined") return;
  try {
    sessionStorage.setItem(storageKey, JSON.stringify({ ...data, _savedAt: Date.now() }));
  } catch (e) {
    console.warn("[useBorrowerFormDraft] Failed to save draft:", e);
  }
}

export function clearFormDraft(storageKey) {
  if (!storageKey || typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    /* ignore */
  }
}

/**
 * Autosave draft to sessionStorage when form data changes.
 */
export function useBorrowerFormDraft(storageKey, draftSnapshot, enabled = true) {
  const persist = useCallback(() => {
    if (!enabled || !storageKey) return;
    saveFormDraft(storageKey, draftSnapshot);
  }, [storageKey, draftSnapshot, enabled]);

  useEffect(() => {
    if (!enabled || !storageKey) return;
    const timer = setTimeout(persist, 400);
    return () => clearTimeout(timer);
  }, [persist, enabled, storageKey]);

  return { saveNow: persist, clear: () => clearFormDraft(storageKey) };
}
